import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-3 py-4 sm:px-6" data-id="element-112" data-mp="17ws2s9xeyodg">
      <div className="mx-auto max-w-xl text-center" data-id="element-113" data-mp="1mmqz075erpqa">
        <p className="inline-block rounded-full bg-gold px-3 py-0.5 font-heading text-[0.65rem] font-extrabold uppercase tracking-widest text-navy sm:text-xs" data-id="element-114" data-mp="1hnw80hxaeuv3">
          Special launch offer
        </p>
        <h2 className="mt-1.5 text-lg font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-115" data-mp="p0a75hfg24bx">
          🧠 NEUROLOGY VISUAL ATLAS™
        </h2>
        <p className="mt-0.5 font-heading text-xs font-semibold uppercase tracking-wide text-electric sm:text-sm" data-id="element-116" data-mp="13uy4u9elrygz">
          The Complete Visual Study System for Neurology Students
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[250px] sm:max-w-[300px]" target="checkout" data-id="element-117" data-mp="2fad45juab2f9" />

        <div className="mt-2 rounded-md border-2 border-gold bg-white px-3 py-2.5 text-left" data-id="element-118" data-mp="2actoqgluojlq">
          <p className="text-center font-heading text-xs font-extrabold uppercase tracking-wide text-navy sm:text-sm" data-id="element-119" data-mp="pjpe89k5neu5">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-120" data-mp="zi4zvx0exvw9">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-121" data-mp="13iyqiy58posu">
                <span className="text-xs leading-tight" aria-hidden="true" data-id="element-122" data-mp="6tpsnwniwhvh">
                  ✅
                </span>
                <span className="text-xs leading-tight sm:text-sm" data-id="element-123" data-mp="bsarpsr1gvic">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2 text-center font-heading text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-124" data-mp="ftm7l6k422dc">
            🔥 GET NEUROLOGY VISUAL ATLAS™ TODAY —{' '}
            <span className="text-mid" data-id="element-125" data-mp="3k9f9o0rcf2nc">$27 USD</span>
          </p>
          <div className="mt-1.5" data-id="element-126" data-mp="3oa7mf3zfbpod">
            <CTAButton label="⚡ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-127" data-mp="3o9fsdxlh6007" />
          </div>
          <p className="mt-1.5 text-center text-[0.65rem] font-bold uppercase tracking-wide sm:text-xs" data-id="element-128" data-mp="qgxh8309b9ov">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}